import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PushNotificationService } from './services/push-notification.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'front-ia-eva';

  constructor(
    private pushNotificationService: PushNotificationService,
    private themeService: ThemeService,
    private router: Router,
  ) {}

  // The admin sidebar shows the version at its foot.
  get isAdminRoute(): boolean {
    return this.router.url.startsWith('/admin');
  }

  ngOnInit(): void {
    // Registro del Service Worker en paralelo, sin bloquear el primer render
    // (mismo espiritu que main.ts con el fetch de config.json).
    this.pushNotificationService.register();

    // Global, independiente de si el widget del toggle se monta o no
    // (el sidebar de admin es su único punto visible ahora).
    this.themeService.init();
  }
}
